import { render, staticRenderFns } from "./holidays.vue?vue&type=template&id=c4d8f20e&"
import script from "./holidays.vue?vue&type=script&lang=js&"
export * from "./holidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "holidays.vue"
export default component.exports